import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import { textTruncate } from '@/helpers/text_truncate';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import { ORANGE, PRIMARY } from '@/helpers/constants/Switch';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
let CardItem = class CardItem extends Mixins(PhotoMixin, OrangeThemeMixin, ViewportSizeMixin, AppDetailsMixin) {
    get truncatedDescription() {
        const description = this.description || '';
        const textWithoutTags = description.replace(/<[^>]+>/g, '');
        const tagLengths = description.length - textWithoutTags.length;
        const length = this.payload ? 80 + tagLengths : 160;
        return textTruncate(description || 'N/A', length);
    }
    get switchColor() {
        return this.orangeTheme ? ORANGE : PRIMARY;
    }
    get skyMatCodeDetails() {
        return `SKU/Mat Code: ${this.skuMatCode}`;
    }
};
__decorate([
    Prop({ type: String, default: null })
], CardItem.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: null })
], CardItem.prototype, "description", void 0);
__decorate([
    Prop({ type: String, default: null })
], CardItem.prototype, "skuMatCode", void 0);
__decorate([
    Prop({ type: String, required: true })
], CardItem.prototype, "uuid", void 0);
__decorate([
    Prop({ type: Boolean })
], CardItem.prototype, "published", void 0);
__decorate([
    Prop({ type: String, default: null })
], CardItem.prototype, "imageUrl", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CardItem.prototype, "hideActions", void 0);
__decorate([
    Prop({ type: Object, default: null })
], CardItem.prototype, "payload", void 0);
__decorate([
    Prop({ type: Object, default: null })
], CardItem.prototype, "referralLink", void 0);
CardItem = __decorate([
    Component
], CardItem);
export default CardItem;
